import EmailSetting from "./EmailSetting";

export default EmailSetting;
